// extracted by mini-css-extract-plugin
module.exports = {"starsOuter":"rating-module--starsOuter--3Eetz","row":"rating-module--row--1F2Mo","starsInner":"rating-module--starsInner--3vD9M"};